export default class BulkChecker {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll('input[type="checkbox"][data-provide="bulkChecker"]:not([data-blc-init="1"])').forEach(function (item, key) {
			item.setAttribute('data-blc-init', "1");
			let keyInItems = item.getAttribute('data-blc-key');

			item.addEventListener('change', (e) => {
				let checked = e.currentTarget.checked;

				document.querySelectorAll('input[type="checkbox"][data-provide="bulkCheckerItem"][data-blc-key="' + keyInItems + '"]').forEach(function (checkboxItem, key) {
					checkboxItem.checked = checked;
				});
			});
		});
	}
}
